import { isNullOrUndefined } from 'Util/TypeGuards';
import { BookingSummary } from 'Views/Components/_HumanWritten/BookingSummaryDto';
import { BookingEntity } from '../../../Models/Entities';

export function getTotalPassengerCountFromBooking(booking: BookingEntity) {
	if (isNullOrUndefined(booking.bookedSummary)) {
		return 0;
	}

	return getTotalPassengerCountFromBookingSummary(booking.bookedSummary);
}

export function getTotalPassengerCountFromBookingSummary(bookedSummary?: BookingSummary) {
	if (isNullOrUndefined(bookedSummary)) {
		return 0;
	}

	const adults = bookedSummary?.adultPassengerTickets?.length ?? 0;
	const children = bookedSummary?.childPassengerTickets?.length ?? 0;
	const infants = bookedSummary?.infantPassengerTickets?.length ?? 0;
	const passengerD = bookedSummary?.passengerDTickets?.length ?? 0;
	const passengerE = bookedSummary?.passengerETickets?.length ?? 0;
	const passengerF = bookedSummary?.passengerFTickets?.length ?? 0;
	const passengerG = bookedSummary?.passengerGTickets?.length ?? 0;
	const passengerH = bookedSummary?.passengerHTickets?.length ?? 0;

	return adults + children + infants + passengerD + passengerE + passengerF + passengerG + passengerH;
}
